export default class Fragment {
    constructor(helper) {
        this.$fragment = $.createFragment();
        this.helper = helper;
    }

    get $container() {
        return this.$fragment;
    }

    render() {
    }

    toHtmlString() {
        return this.$fragment[0].innerHTML;
    }
}
